
import repository from '../../repositories/request/request.review.repository';

const normalizeChecklistItem = (item) => {
    if (!item || typeof item !== 'object') return item;

    return {
        description: item.description || '',
        answer: item.answer === undefined ? null : item.answer,
        userId: item.userId || item.user_id || null,
        source: item.source || null,
        sourceLabel: item.source_label || item.sourceLabel || null,
        evidenceSnippet: item.evidence_snippet || item.evidenceSnippet || null,
        evidencePages: item.evidence_pages || item.evidencePages || null,
        isRepeatOf: item.is_repeat_of || item.isRepeatOf || null,
        firstSeenVersion: item.first_seen_version != null
            ? item.first_seen_version
            : (item.firstSeenVersion != null ? item.firstSeenVersion : null)
    };
};

const pickDefined = (...values) => {
    for (const v of values) {
        if (v !== undefined && v !== null) return v;
    }
    return null;
};

const normalizeReview = (review) => {
    if (!review || typeof review !== 'object') return review;

    return {
        ...review,
        checklist: Array.isArray(review.checklist) ? review.checklist.map(normalizeChecklistItem) : [],
        documentId: pickDefined(review.documentId, review.document_id),
        schemaVersion: pickDefined(review.schemaVersion, review.schema_version),
        isLegacy: review.isLegacy !== undefined ? review.isLegacy : review.is_legacy,
        hasMajorErrors: review.hasMajorErrors !== undefined ? review.hasMajorErrors : review.has_major_errors,
        senderUserId: pickDefined(review.senderUserId, review.sender_user_id),
        senderName: pickDefined(review.senderName, review.sender_name),
        unlinkedAt: pickDefined(review.unlinkedAt, review.unlinked_at),
        unlinkInfo: pickDefined(review.unlinkInfo, review.unlink_info),
        unlinkReasonItems: review.unlinkReasonItems || review.unlink_reason_items || [],
        correctionVersion: pickDefined(review.correctionVersion, review.correction_version),
        createdAt: pickDefined(review.createdAt, review.created_at),
        faciliterAnsweredPrevious: review.faciliterAnsweredPrevious !== undefined
            ? review.faciliterAnsweredPrevious
            : (review.faciliter_answered_previous !== undefined ? review.faciliter_answered_previous : null)
    };
};

const findByRequestId = async (requestId) =>
    repository.findByRequestId(requestId).then(res => res.data);

const findAllReviewsByRequestId = async (requestId) =>
    repository.findAllReviewsByRequestId(requestId).then(res => {
        const raw = res.data;
        if (!Array.isArray(raw)) return raw;
        return raw.map(normalizeReview);
    });

const saveReview = async (requestId, data) =>
    repository.saveReview(requestId, data).then(res => res.data);

export default {
    findByRequestId,
    findAllReviewsByRequestId,
    saveReview,
    normalizeReview,
    normalizeChecklistItem
}
